import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatInput, MatLabel } from '@angular/material/input';

interface ApiKeyRequestDenyDialogData {
  userName: string;
}

@Component({
  selector: 'tgrid-api-key-request-deny-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
  ],
  templateUrl: './api-key-request-deny-dialog.component.html',
  styleUrl: './api-key-request-deny-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiKeyRequestDenyDialogComponent {
  protected readonly data = inject<ApiKeyRequestDenyDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<ApiKeyRequestDenyDialogComponent>);
  private readonly formBuilder = inject(FormBuilder);

  protected readonly form = this.formBuilder.nonNullable.group({
    deniedReason: ['', [Validators.required, Validators.maxLength(1000)]],
  });

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.controls.deniedReason.value.trim());
  }
}

